(() => {
  'use strict';
  const config = document.querySelector('[data-d13-config]');
  if (!config) return;
  const words = config.dataset;
  const text = (tag, value) => { const node = document.createElement(tag); node.textContent = value; return node; };
  const flat = value => String(value || '').replace(/[\r\n]+/g, ' ').trim();
  function unpack(entry) {
    const html = new DOMParser().parseFromString(String(entry.content || ''), 'text/html');
    html.querySelectorAll('br').forEach(node => node.replaceWith('\n'));
    html.querySelectorAll('p,div').forEach(node => node.append('\n'));
    const content = html.body.textContent.trim();
    const line = content.split('\n')[0];
    if (!line.startsWith('[DREP_REVIEW_V1]')) return null;
    try {
      const meta = JSON.parse(decodeURIComponent(line.slice('[DREP_REVIEW_V1]'.length)));
      const body = content.slice(line.length).trim();
      if (!Number.isInteger(meta.rating) || meta.rating < 1 || meta.rating > 5 || meta.consent !== 'yes' || body.length < 15) return null;
      return { rating: meta.rating, title: flat(meta.title).slice(0, 100), context: flat(meta.context).slice(0, 100), body: body.slice(0, 2000), name: flat(entry.name).slice(0, 60), date: entry.date };
    } catch { return null; }
  }
  const card = review => {
    const node = document.createElement('article'); node.className = 'd12-review-card d14-review-card';
    const stars = text('span', '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating));
    stars.className = 'd14-stars'; stars.setAttribute('aria-label', words.stars.replace('__RATING__', review.rating));
    node.append(stars);
    if (review.title) node.append(text('h3', review.title));
    node.append(text('blockquote', review.body));
    const attribution = document.createElement('footer');
    attribution.append(text('strong', review.name), text('span', [review.context, review.city].filter(Boolean).join(' · ')));
    if (review.demo) attribution.append(text('small', words.testProfile));
    node.append(attribution);
    return node;
  };
  const fetchTimed = async url => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try { return await fetch(url, { credentials: 'same-origin', signal: controller.signal }); }
    finally { clearTimeout(timeout); }
  };
  let loading;
  async function approvedReviews() {
    const result = []; const seen = new Set(); let page = 1;
    while (page !== null) {
      if (!Number.isInteger(page) || page < 1 || seen.has(page)) throw new Error('Invalid pagination');
      seen.add(page);
      const url = new URL(words.endpoint, location.origin); url.searchParams.set('page', page);
      const response = await fetchTimed(url);
      if (!response.ok) throw new Error('Reviews unavailable: ' + response.status);
      const data = await response.json();
      if (!Array.isArray(data.reviews) || !(data.next === null || Number.isInteger(data.next))) throw new Error('Invalid reviews');
      for (const entry of data.reviews) { const review = unpack(entry); if (review) result.push(review); }
      page = data.next;
    }
    return result;
  }
  async function availableReviews() {
    if (words.testMode !== 'true' || !words.demo) return approvedReviews();
    const response = await fetchTimed(words.demo);
    if (!response.ok) throw new Error('Test reviews unavailable');
    const data = await response.json();
    if (!Array.isArray(data.reviews)) throw new Error('Invalid test reviews');
    return data.reviews.filter(r => r.demo === true && Number.isInteger(r.rating) && r.rating >= 1 && r.rating <= 5);
  }
  function renderReviews(reviews) {
    const count = reviews.length;
    const average = count ? new Intl.NumberFormat(document.documentElement.lang || 'de', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(reviews.reduce((sum, review) => sum + review.rating, 0) / count) : '—';
    const label = count ? words.summary.replace('__AVERAGE__', average).replace('__COUNT__', count) : words.read;
    document.querySelectorAll('[data-d13-summary-label]').forEach(node => { node.textContent = node.closest('.d14-rating-panel') && count ? count + ' Bewertungen' : label; });
    document.querySelectorAll('[data-d13-summary] .d14-stars').forEach(node => { node.hidden = !count; node.style.setProperty('--rating-fill', count ? (reviews.reduce((sum, r) => sum + r.rating, 0) / count / 5 * 100) + '%' : '0%'); });
    document.querySelectorAll('[data-d14-average]').forEach(node => { node.textContent = average; });
    if (count && !reviews.some(r => r.demo)) document.querySelectorAll('[data-d13-example]').forEach(node => { node.hidden = true; });
    document.querySelectorAll('[data-d14-distribution]').forEach(root => {
      root.replaceChildren();
      for (let rating = 5; rating >= 1; rating--) {
        const total = reviews.filter(review => review.rating === rating).length;
        const row = document.createElement('div'); row.className = 'd14-distribution-row';
        const bar = document.createElement('meter'); bar.min = 0; bar.max = Math.max(1, count); bar.value = total; bar.setAttribute('aria-label', words.stars.replace('__RATING__', rating));
        row.append(text('span', rating + ' ★'), bar, text('span', total)); root.append(row);
      }
    });
    document.querySelectorAll('[data-d13-reviews]').forEach(root => {
      const list = root.querySelector('[data-d13-list]'); if (!list) return;
      const filter = root.querySelector('[data-d14-filter]'), sort = root.querySelector('[data-d14-sort]');
      const prev = root.querySelector('[data-d14-prev]'), next = root.querySelector('[data-d14-next]');
      let page = 1; const size = 12;
      const draw = scroll => {
        let shown = reviews.filter(r => !filter || filter.value === 'all' || r.rating === Number(filter.value));
        shown = [...shown].sort((a,b) => sort?.value === 'highest' ? b.rating-a.rating : sort?.value === 'lowest' ? a.rating-b.rating : String(b.date||'').localeCompare(String(a.date||'')));
        const pages = Math.max(1, Math.ceil(shown.length/size)); page = Math.max(1, Math.min(page, pages));
        const start = (page-1)*size, end = Math.min(start+size, shown.length);
        list.replaceChildren(...shown.slice(start,end).map(card));
        if (!shown.length) list.append(text('p', reviews.length ? words.zeroResults : words.empty));
        const results = root.querySelector('[data-d14-results]');
        if (results) results.textContent = words.results.replace('__START__', shown.length ? start+1 : 0).replace('__END__', end).replace('__COUNT__', shown.length);
        const indicator = root.querySelector('[data-d14-page]');
        if (indicator) indicator.textContent = words.page.replace('__CURRENT__', page).replace('__PAGES__', pages);
        if (prev) prev.disabled = page === 1; if (next) next.disabled = page === pages;
        if (scroll) root.querySelector('.d14-review-directory')?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      };
      if (!root.dataset.pagerReady) {
        root.dataset.pagerReady = 'true';
        filter?.addEventListener('change', () => { page=1; draw(false); });
        sort?.addEventListener('change', () => { page=1; draw(false); });
        prev?.addEventListener('click', () => { page--; draw(true); });
        next?.addEventListener('click', () => { page++; draw(true); });
      }
      draw(false);
    });
    document.querySelectorAll('[data-d13-teaser]').forEach(list => { list.replaceChildren(...reviews.slice(0,3).map(card)); });
  }
  function init() {
    document.querySelectorAll('[data-d13-reviews] form').forEach(form => {
      if (form.dataset.d13Ready) return;
      form.dataset.d13Ready = 'true';
      const packed = form.querySelector('[data-d13-packed]');
      const send = form.querySelector('[data-d13-send]');
      const field = name => form.elements.namedItem(name);
      if (packed.value) {
        const restored = unpack({ content: packed.value });
        if (restored) { field('review_rating').value = String(restored.rating); field('review_title').value = restored.title; field('review_context').value = restored.context; field('review_body').value = restored.body; }
      }
      const pack = () => {
        const meta = { rating: Number(field('review_rating').value), title: flat(field('review_title').value), context: flat(field('review_context').value), consent: field('review_consent').checked ? 'yes' : 'no' };
        const header = encodeURIComponent(JSON.stringify(meta));
        packed.value = '[DREP_REVIEW_V1]' + header + '\n\n' + field('review_body').value.trim();
      };
      form.addEventListener('input', pack); form.addEventListener('change', pack); form.addEventListener('submit', pack, true);
      send.disabled = false;
    });
    document.querySelectorAll('[data-r-bundle]').forEach(radio => {
      if (radio.dataset.d13Ready) return; radio.dataset.d13Ready = 'true';
      radio.addEventListener('change', () => { document.querySelectorAll('[data-d13-sticky-pack]').forEach(node => { node.textContent = words.pack.replace('__COUNT__', radio.value); }); });
    });
    document.querySelectorAll('[data-d8-bundle]').forEach(radio => {
      if (radio.dataset.d13Ready) return; radio.dataset.d13Ready = 'true';
      radio.addEventListener('change', () => { document.querySelectorAll('[data-d13-pack]').forEach(node => { node.textContent = words.pack.replace('__COUNT__', radio.value); }); });
    });
    const selected = document.querySelector('[data-r-bundle]:checked');
    if (selected) document.querySelectorAll('[data-d13-sticky-pack]').forEach(node => { node.textContent = words.pack.replace('__COUNT__', selected.value); });
    loading ||= availableReviews();
    loading.then(renderReviews).catch(error => {
      console.warn('DREP reviews:', error.message);
      document.querySelectorAll('[data-d13-load-status]').forEach(node => { node.textContent = words.error; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
